import Swal from 'sweetalert2';

/**
 * Take in an event and extract the inner text of the target to copy to clipboard and
 * display as a Toast
 * @param {event} e
 */
async function copyTargetText(e) {
  try {
    const text = e.target.innerText;
    await navigator.clipboard.writeText(text).then(() => {
      if (text !== '-')
        Swal.fire({
          title: `Copied: ${text}`,
          icon: 'success',
          toast: true,
          position: 'bottom-right',
          showConfirmButton: true,
        });
    });
  } catch (err) {
    console.error('Failed to copy: ', err);
  }
}

export default copyTargetText;
